'use strict';

function controller ($rootScope) {
    const ctrl = this;

    ctrl.tagSelect = (code, displayNm, count) => {
        $rootScope.$broadcast('tagChange', {
            code,
            displayNm,
            count
        });
    };
}

controller.$inject = ['$rootScope'];

export default controller;
